<template>
  <div class="modal fade" id="AgreementModal" tabindex="-1" aria-labelledby="AgreementModalLabel" @keydown.esc="clearForm(false)">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="clientModalLabel">Список получатели</h5>
          <button type="button" @click="clearForm(false)" class="btn-close"></button>
        </div>
        <div class="modal-body p-5">
          <input v-if="form.id" v-model="form.id" type="hidden">
          <input-field
              v-model="form.title"
              id="form.title"
              name=form.title
              :required="true"
              placeholder="Наименование"
              type="text"
              mb="5"
          />
          <area-field
              v-model="form.description"
              id="form.description"
              name="form.description"
              class="h-auto h-100px mb-5"
              placeholder="Описание"
          />
          <div v-if="!form.document" class="form-floating mb-5">
            <input type="file" accept=".pdf" @change="handleFileChange" class="form-control form-control-solid" id="form.document" />
            <label for="form.document">Документ (pdf)</label>
          </div>
          <div v-else>
            <object
                :data="form.document+'#view=Fit'"
                class="mb-5"
                type="application/pdf"
                width="100%"
                style="height: 40vh"
            />
            <div class="btn btn-sm btn-light-danger mb-5 d-block" @click="form.document = null">Удалить файл</div>
          </div>
          <select-field
              v-model="form.status"
              id="form.status"
              name=form.status
              :options="{0:'Неактивный', 1:'Активный'}"
              :required="true"
              placeholder="Статус"
              mb="5"
          />
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button @click="clearForm(false)" class="btn btn-sm btn-light-warning" type="button">Закрыть</button>
          <button
              :disabled="!form.title || !form.document"
              @click="setAgreement()"
              type="button"
              class="btn btn-sm btn-primary"
              v-html="form.id ? 'Обновить' : 'Создать'"
          ></button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
// Fields
import SelectField from '@/components/Fields/SelectField'
import InputField  from '@/components/Fields/InputField'
import AreaField   from '@/components/Fields/AreaField'
// Other
import LoaderFull from '@/components/Main/LoaderFull'
import axios      from 'axios'
export default {
  name: 'AgreementModal',
  components: {AreaField, SelectField, InputField, LoaderFull},
  props: {
    agreementData: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      loader: false,
      form: {
        id:          null,
        title:       null,
        description: null,
        document:    null,
        status:      1
      },
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById('AgreementModal').addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) this.clearForm(false)
      });
    }, 10)
  },
  methods: {
    clearForm(isUpdateList) {
      this.form = {
        id:          null,
        title:       null,
        description: null,
        document:    null,
        status:      1
      }
      this.loader = false
      this.$emit('close', {update: isUpdateList})
    },
    setAgreement() {
      this.loader = true
      const headers = this.form
      axios.post('/api/admin/agreement/admin/set', headers)
          .then(res => {
            if (res.data.id) this.clearForm(true)
          })
          .catch(err => {console.log(err)})
          .finally(() => this.loader = false)
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type === "application/pdf") {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.form.document = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.form.document = null
        document.getElementById("form.document").value = '';
        alert("Пожалуйста, выберите файл формата PDF.");
      }
    },
  },
  watch: {
    agreementData: {
      immediate: true,
      handler(val) {
        this.form = val
      }
    }
  }
}
</script>

<style scoped>

</style>